import React from 'react';

const LBHireDesignersApp = () => {
  return (
    <div style={{ width: '100%', height: '100vh', overflow: 'hidden' }}>
      <iframe
        src="/projectList/lb-hire-designers.html"
        title="Eka Portfolio App"
        style={{ width: '100%', height: '100%', border: 'none' }}
      />
     
    </div>
    
  );
}

export default LBHireDesignersApp;